import { Canvas } from '@studio/design-system/canvas';
import type { CanvasContext } from '@studio/design-system/canvas';
import { useUpdateEffect, χref } from '@studio/react-utils/hooks';
import { useRef } from 'react';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import type { GridProps } from './types.js';
import { drawLines } from './utils.js';

/** `<Grid>` lines component. */
export const Grid = ({ className, gridLines, ...props }: GridProps): ReactElement => {
  const canvasRef = useRef<CanvasContext>(null);

  // Re-draw anytime the selected grid lines change.
  useUpdateEffect(() => {
    χref(canvasRef)?.draw();
  }, [gridLines]);

  return (
    <Canvas
      className={twMerge('stroke-warning', className)}
      onDraw={(context): void => {
        drawLines(context, gridLines);
      }}
      ref={canvasRef}
      {...props}
    />
  );
};
